import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home-photo.png";
import homeImg from "../../Assets/favrhoodapp.png";
import Tilt from "react-parallax-tilt";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import useInViewOnce from "../../hooks/useInViewOnce";

import { Trans, useTranslation } from "react-i18next";



function Home2() {

  const { t } = useTranslation();

  const { ref: innovationRef, inView: innovationInView } = useInViewOnce({
    threshold: 0.2,
    once: false,
  });

  const { ref: entrepreneurshipRef, inView: entrepreneurshipInView } = useInViewOnce({
    threshold: 0.2,
    once: false,
  });

  const { ref: socialContributionRef, inView: socialContributionInView } = useInViewOnce({
    threshold: 0.2,
    once: false,
  });

  const handleClick = () => {
    window.open("https://www.favrhood.com/", "_blank", "noopener,noreferrer");
  };


  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 className="home-about-title">
              {t("home.about.titleEmpowering")} <span className="purple"> {t("home.about.titleInnovating")} </span>{" "}
              {t("home.about.titleEducating")}
            </h1>
            <p className="home-about-body">
              <Trans
                i18nKey="home.about.body"
                components={{
                  br: <br />,
                  b: <b className="purple" />,
                  r: <span className="small-r-symbol">®</span>,
                }}
              />
      
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <div className="policy-card home2-avatar-card">
              <Tilt className="home2-avatar-tilt" tiltMaxAngleX={8} tiltMaxAngleY={8}>
                <img src={myImg} className="img-fluid home2-avatar-img" alt={t("home.a11y.avatarAlt")} />
              </Tilt>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>
              {t("home.fostering.prefix")}{" "}
              <span className="purple">{t("home.fostering.innovation")}</span>,{" "}
              <span className="purple">{t("home.fostering.entrepreneurship")}</span>, {t("home.fostering.and")} {" "}
              <span className="purple"> {t("home.fostering.socialContribution")} </span>
            </h1>
            <div
              className="foster-cards"
              role="list"
              aria-label={t("home.a11y.fosterListLabel")}
            >
              <div
                ref={innovationRef}
                className={`foster-card-wrap${innovationInView ? " is-seen" : ""}`}
                role="listitem"
                style={{ "--foster-delay": "0ms" }}
              >
                <Card className="foster-card">
                  <Card.Body>
                    <Card.Title className="foster-card-title">{t("home.fosterCards.innovation.title")}</Card.Title>
                    <Card.Text className="foster-card-text">
                      {t("home.fosterCards.innovation.text")}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div
                ref={entrepreneurshipRef}
                className={`foster-card-wrap${entrepreneurshipInView ? " is-seen" : ""}`}
                role="listitem"
                style={{ "--foster-delay": "120ms" }}
              >
                <Card className="foster-card">
                  <Card.Body>
                    <Card.Title className="foster-card-title">{t("home.fosterCards.entrepreneurship.title")}</Card.Title>
                    <Card.Text className="foster-card-text">
                      {t("home.fosterCards.entrepreneurship.text")}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div
                ref={socialContributionRef}
                className={`foster-card-wrap${socialContributionInView ? " is-seen" : ""}`}
                role="listitem"
                style={{ "--foster-delay": "240ms" }}
              >
                <Card className="foster-card">
                  <Card.Body>
                    <Card.Title className="foster-card-title">{t("home.fosterCards.socialContribution.title")}</Card.Title>
                    <Card.Text className="foster-card-text">
                      {t("home.fosterCards.socialContribution.text")}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <Button onClick={handleClick} className="custom-yellow-btn home2-cta-btn">
              {t("home.about.cta")}
            </Button>

            <Row className="justify-content-center mt-4">
              <Col xs={12} sm={10} md={8} lg={6} className="text-center">
                <Tilt className="favrhood-tilt" tiltMaxAngleX={6} tiltMaxAngleY={6}>
                  <img
                    src={homeImg}
                    className="img-fluid favrhood-img"
                    alt={t("home.a11y.favrhoodPreviewAlt")}
                  />
                </Tilt>
              </Col>
            </Row>
    
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
